import { UserManager, WebStorageStateStore, type User } from 'oidc-client-ts';
import { env } from '@/config/env';

class OidcService {
  private manager: UserManager | null = null;

  private get userManager(): UserManager {
    this.manager ??= new UserManager({
      authority: env.VITE_OIDC_AUTHORITY,
      client_id: env.VITE_OIDC_CLIENT_ID,
      redirect_uri: env.VITE_OIDC_REDIRECT_URI,
      post_logout_redirect_uri: env.VITE_OIDC_POST_LOGOUT_REDIRECT_URI,
      scope: env.VITE_OIDC_SCOPE,
      response_type: 'code',
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      automaticSilentRenew: true,
    });
    return this.manager;
  }

  async getUser(): Promise<User | null> {
    return this.userManager.getUser();
  }

  async getAccessToken(): Promise<string | null> {
    const user = await this.getUser();
    return user?.access_token ?? null;
  }

  async refresh(): Promise<boolean> {
    try {
      const renewed = await this.userManager.signinSilent();
      return renewed !== null;
    } catch (err) {
      console.warn('[OIDC] silent renew failed', err);
      return false;
    }
  }

  async signin(): Promise<void> {
    await this.userManager.signinRedirect();
  }

  async signout(): Promise<void> {
    await this.userManager.signoutRedirect();
  }
}

export const oidcService = new OidcService();
